import * as React from 'react'
import { useEffect } from 'react'

import Persistence from '@paytrace/pt-skel/Context/Persistence'
import { frown } from '@paytrace/pt-skel/Icon'

interface P {
  url: string
}

export function NotFound (props: P) {
  const referrer = Persistence.getItem('sso-referrer')

  useEffect(() => {
    // If they had came in via SSO, we know where to bounce them on invalid pages.
    if (referrer) {
      window.location.href = referrer + window.location.pathname
    }

    return () => {}
  }, [referrer])

  if (referrer) {
    // Simulate a full page clear so it isn't apparent to the user redirect
    // is happening (there is a small pause between component and redirect)
    return (
      <div style={{
        position: 'absolute',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%',
        background: '#fff',
      }} >
        &nbsp;
      </div>
    )
  }

  return (
    <div className='center'>
      <h1 className='error'>404 Not Found</h1>
      <div className='giant-text'>{frown}</div>
      <p>The requested url was:</p>
      <p>/{props.url}</p>
    </div>
  )
}

export default NotFound
